import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ConfigProvider } from 'antd';

import ProgressBar from 'components/ProgressBar';
import { Model } from 'components/Model';
import SnackbarAlert from 'components/Snackbar';
import Overlay from 'components/Overlay';
import NotFound from 'components/PageNotFound';

import { PublicRoutes } from './publicRoutes';
import { StoreRoutes } from './storeRoutes';
import { PortalRoutes } from './portalRoutes';
import { InstantRenewalRoutes } from './instantRenewalRoutes';

const App = () => {
  // Use server-generated nonce from backend (Thymeleaf provides window.cspNonce)
  const nonce = window.cspNonce || 'fallback-nonce-for-development';

  // Log nonce status for debugging
  console.log('CSP Nonce Status:', {
    nonce: nonce.substring(0, 10) + '...',
    isServerGenerated: !!window.cspNonce,
    isFallback: !window.cspNonce
  });

  return (
    <ConfigProvider csp={{ nonce }}>
      <Router>
        <Suspense fallback={<ProgressBar />}>
          <Routes>
            {PublicRoutes()}
            {PortalRoutes()}
            {StoreRoutes()}
            {InstantRenewalRoutes()}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <Model />
      </Router>
      <SnackbarAlert />
      <Overlay />
    </ConfigProvider>
  );
};

export default App;
